import { useNavigate, useParams } from "react-router-dom";
import BaseContainerWrapper from "../../common/components/BaseContainerWrapper";
import useComponents from "../../common/hooks/pages/useComponents";
import ComponentForm from "../components/IncidentFormLayout";
import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import { useEffect } from "react";

function Incident() {
  const navigate = useNavigate();

  const { id } = useParams();

  const { createIncident, getIncidents } = useComponents();

  const { toast } = usePopup();

  const { mutate: createIncidentMutate, isLoading: isCreating } = useMutation({
    mutationFn: createIncident,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/incidents");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating Incident!";
      toast(message, "error");
    },
  });

  const {
    data,
    mutate: getIncidentsMutate,
    isLoading: isGetting,
  } = useMutation({
    mutationFn: getIncidents,

    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting Incident!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    if (id) {
      getIncidentsMutate(id);
    }
  }, []);

  const { component } = data?.data || {};
  return (
    <BaseContainerWrapper>
      <ComponentForm
        onSubmit={(data) => createIncidentMutate(data)}
        isSubmitting={isCreating}
        component={component}
        id={id}
      />
    </BaseContainerWrapper>
  );
}

export default Incident;
